import { createElement } from 'react';
import './notice-bar-item.scss';
import { convertChildren } from '../../utils/children-node-handle';
import { formatTime } from '../../utils/time-util';
const NoticeBarItem = ({ content, releaseTime, isTop, children, ...otherProps }) => {
    const _otherProps = otherProps || {};
    releaseTime = formatTime(releaseTime);
    console.log(convertChildren(children, isTop === 1 ? 'teletext-tagc-1' : 'teletext-tagc-2', {
        name: isTop === 1 ? '置顶' : '最新',
    }));
    return (createElement("div", { className: "notice-bar__panel__item", ..._otherProps },
        createElement("div", { className: "notice-bar__panel__item-left" },
            convertChildren(children, isTop === 1 ? 'teletext-tagc-1' : 'teletext-tagc-2', {
                name: isTop === 1 ? '置顶' : '最新',
            }),
            createElement("div", { className: "notice-bar__panal__item__content" }, content))));
};
NoticeBarItem.displayName = 'NoticeBarItem';
export default NoticeBarItem;
